
import { Options, Vue } from "vue-class-component";
import { useStore }     from "vuex";
import { key }          from "@/store";

import { library }                                          from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon }                                  from "@fortawesome/vue-fontawesome";
import { faCaretUp, faCaretDown, faCheckCircle, faSpinner } from "@fortawesome/free-solid-svg-icons";

library.add( faCaretUp, faCaretDown, faCheckCircle, faSpinner );

@Options( {
  components : { FontAwesomeIcon }
} )
export default class Boxes extends Vue
{
  store              = useStore( key );
  gm                 = this.store.state.gm;
  box_shown          = 3;
  question_shown     = false;
  selected_box : any = {};
  loading            = false;
  success            = false;
  error              = "";
  window             = window;

  // Form data model
  reservation_name     = "";
  reservation_surname  = "";
  reservation_email    = "";
  reservation_phone    = "";
  reservation_date     = "";
  reservation_question = "";

  // Handling for submissions
  submit()
  {
    this.loading = true;
    this.error   = "";

    let formData = new FormData();
    formData.append( "firstname",   this.reservation_surname );
    formData.append( "lastname",    this.reservation_name );
    formData.append( "email",       this.reservation_email );
    formData.append( "phone",       this.reservation_phone );
    formData.append( "approx_date", this.reservation_date );
    formData.append( "message",     this.reservation_question );

    // Hidden fields
    formData.append( "gm_id",     this.store.state.gm.id );
    formData.append( "box_id",    this.selected_box.id );
    formData.append( "type",      "reservation" );

    try
    {
      let request = fetch( this.store.state.api + "demande", {
        method  : "POST",
        cache   : "no-cache",
        body    : formData
      } );

      request.then( ( res ) => { return res.json(); } ).then( this.ajaxSuccess );
      request.catch( this.ajaxError );
    }
    catch( e )
    {
      this.ajaxError( e );
    }
  }

  ajaxSuccess( response : any )
  {
    if( response.success ?? response.data?.success )
    {
      this.success = true;
      this.loading = false;
    }
    else
    {
      this.ajaxError( response );
    }
  }

  ajaxError( response : any )
  {
    this.success = false;
    this.loading = false;
    this.error   = response.error ?? response.data?.error ?? response.errors?.error ?? "Une erreur est survenue";
  }

  selectBox( box : object )
  {
    if( !this.loading )
    {
      this.selected_box = ((this.selected_box === box) ? {} : box);
      this.success      = false;
      this.loading      = false;
    }
  }

  boxes( boxes : any )
  {
    boxes = boxes.filter( ( box : any ) => typeof box.available === 'undefined' || box.available > 0 );
    return boxes.slice( 0, this.box_shown );
  }
}
